import React, { FormEvent, useState } from 'react';
import { Send, CheckCircle } from 'lucide-react';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    plan: '',
    message: ''
  });
  const [showSuccess, setShowSuccess] = useState(false);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    
    // Prepare email subject and body
    const subject = encodeURIComponent('Quero saber mais sobre o Método PDTE');
    const body = encodeURIComponent(
      `Nova mensagem do site PDTE\n\n` +
      `Nome: ${formData.name}\n` +
      `Email: ${formData.email}\n` +
      `Telefone: ${formData.phone}\n` +
      `Plano: ${formData.plan}\n\n` +
      `Expectativas:\n${formData.message}`
    );

    // Open default email client with pre-filled message
    window.location.href = `mailto:profissionalisabellereis@gmail.com?subject=${subject}&body=${body}`;
    
    // Show success message
    setShowSuccess(true);
    
    // Reset form
    setFormData({
      name: '',
      email: '',
      phone: '',
      plan: '',
      message: ''
    });

    // Hide success message after 5 seconds
    setTimeout(() => {
      setShowSuccess(false);
    }, 5000);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  return (
    <section id="contact" className="py-20 bg-secondary/20">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4">
              Fale Conosco
            </h2>
            <p className="text-xl text-primary/80">
              Dê o primeiro passo para transformar sua redação. Entre em contato conosco hoje mesmo.
            </p>
          </div>

          <div className="bg-white rounded-2xl shadow-xl p-8 border border-primary/10">
            {showSuccess && (
              <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-lg flex items-center justify-center text-green-600">
                <CheckCircle className="h-5 w-5 mr-2" />
                <span>Mensagem enviada com sucesso! Em breve entraremos em contato.</span>
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-primary mb-1">
                    Nome Completo
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full px-4 py-2 border border-primary/20 rounded-lg focus:ring-2 focus:ring-accent focus:border-transparent bg-white/50"
                    required
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-primary mb-1">
                    E-mail
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full px-4 py-2 border border-primary/20 rounded-lg focus:ring-2 focus:ring-accent focus:border-transparent bg-white/50"
                    required
                  />
                </div>
              </div>

              <div>
                <label htmlFor="phone" className="block text-sm font-medium text-primary mb-1">
                  Telefone
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="(00) 00000-0000"
                  className="w-full px-4 py-2 border border-primary/20 rounded-lg focus:ring-2 focus:ring-accent focus:border-transparent bg-white/50"
                  required
                />
              </div>

              <div>
                <label htmlFor="plan" className="block text-sm font-medium text-primary mb-1">
                  Plano de Interesse
                </label>
                <select
                  id="plan"
                  name="plan"
                  value={formData.plan}
                  onChange={handleChange}
                  className="w-full px-4 py-2 border border-primary/20 rounded-lg focus:ring-2 focus:ring-accent focus:border-transparent bg-white/50"
                  required
                >
                  <option value="">Selecione um plano</option>
                  <option value="Plano UP (Ensino Fundamental)">Plano UP (Ensino Fundamental)</option>
                  <option value="Plano Avança (1º e 2º anos)">Plano Avança (1º e 2º anos)</option>
                  <option value="Mentoria Individual (3º ano e Ex-Alunos)">Mentoria Individual (3º ano e Ex-Alunos)</option>
                </select>
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-medium text-primary mb-1">
                  Conte-nos sobre suas expectativas
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows={4}
                  className="w-full px-4 py-2 border border-primary/20 rounded-lg focus:ring-2 focus:ring-accent focus:border-transparent bg-white/50"
                  required
                ></textarea>
              </div>

              <div className="text-center">
                <button
                  type="submit"
                  className="inline-flex items-center px-8 py-3 bg-accent text-white rounded-full hover:bg-accent-dark transition-colors"
                >
                  <Send className="h-5 w-5 mr-2" />
                  Enviar Mensagem
                </button>
              </div>
            </form>

            <div className="mt-8 pt-8 border-t border-primary/10">
              <p className="text-center text-primary/80">
                Vagas limitadas! Garanta sua prioridade para 2025.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;